import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { ScheduleTriggerConfig } from './ScheduleTriggerConfig';
import {
  ScheduleTriggerNode,
  scheduleTriggerVisualDefinition,
} from './ScheduleTriggerNode';
import {
  ScheduleTriggerConfigType,
  defaultScheduleTriggerConfig,
  validateScheduleTriggerConfig,
  getScheduleTriggerPreviewText,
} from './schema';

export { ScheduleTriggerNode } from './ScheduleTriggerNode';
export { ScheduleTriggerConfig } from './ScheduleTriggerConfig';
export type { ScheduleTriggerConfigType } from './schema';

/** Full definition for the registry */
export const scheduleTriggerDefinition: NodeDefinition<ScheduleTriggerConfigType> =
  {
    ...scheduleTriggerVisualDefinition,
    category: 'trigger',
    NodeComponent: ScheduleTriggerNode as unknown as React.ComponentType<
      NodeProps<Node<BaseNodeData>>
    >,
    ConfigComponent: ScheduleTriggerConfig,
    defaultConfig: () => ({ ...defaultScheduleTriggerConfig }),
    validateConfig: validateScheduleTriggerConfig,
    getPreviewText: getScheduleTriggerPreviewText,
  };
